import { lazy } from 'react';

export const projectRegistry = {
  HSD:              lazy(() => import('../HSD/HSD')),
  SharpSchool:      lazy(() => import('../SharpSchool/SharpSchool')),
  Elevator:         lazy(() => import('../Elevator/Elevator')),
  TailVirus:        lazy(() => import('../genetic_virus/TailVirus')),
  BwO:              lazy(() => import('../BwO/BwO')),
  CinemaMeowdiso:   lazy(() => import('../CinemaMeowdiso/CinemaMeowdiso')),
  AbuttingTokyo:    lazy(() => import('../AbuttingTokyo/AbuttingTokyo')),
  Colearning:       lazy(() => import('../Colearning/Colearning')),
  EmbeddingOcean:   lazy(() => import('../EmbeddingOcean/EmbeddingOcean')),
  DynamicLandscape: lazy(() => import('../DynamicLandscape/DynamicLandscape')),
};

export const getProjectComponent = (key) => projectRegistry[key] ?? null;
